import get from 'transmute/get';
export const getTypingMessageShouldDisableUserInput = get('shouldDisableUserInput');